import 'core-js/modules/es.object.assign.js';
import { __awaiter } from '../../../../_virtual/_tslib.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { Box, Text, Link, Stack } from '@hub-la/design-system';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import { GetFirstName } from '../../../usecases/get-first-name.js';
import { AccountCard } from '../../components/account-card.js';
import { useGetMyAccess } from '../../hooks/use-get-my-access.js';
import { useRoleplay } from '../../hooks/use-roleplay.js';
import { SelectAccountLoadingState } from './loading-state.js';

const SelectAccountRoleplayPage = ({
  currentUser
}) => {
  const history = useHistory();
  const {
    t
  } = useTranslation();
  const {
    data,
    isFetching
  } = useGetMyAccess();
  const {
    isRoleplay,
    signIn,
    signOut,
    signInLoading,
    signOutLoading
  } = useRoleplay();
  const handleSignIn = id => __awaiter(void 0, void 0, void 0, function* () {
    yield signIn(id);
    history.push('/dashboard');
  });
  const handleSignOut = () => __awaiter(void 0, void 0, void 0, function* () {
    if (!isRoleplay) {
      history.push('/dashboard');
      return;
    }
    yield signOut();
    history.push('/dashboard');
  });
  return jsxs(Box, Object.assign({
    maxWidth: 588,
    mx: "auto",
    mt: 8,
    mb: 8
  }, {
    children: [jsx(Text, Object.assign({
      mb: 3,
      variant: "h3"
    }, {
      children: t('selectAccountRoleplay.title', {
        firstName: new GetFirstName().execute(currentUser === null || currentUser === void 0 ? void 0 : currentUser.name)
      })
    })), jsx(Link, {
      children: jsx(Text, {
        children: t('selectAccountRoleplay.helpText')
      })
    }), jsxs(Stack, Object.assign({
      mt: 6
    }, {
      children: [jsx(Text, Object.assign({
        variant: "body1",
        fontWeight: 700,
        mb: 2
      }, {
        children: t('selectAccountRoleplay.yourAccount')
      })), jsx(AccountCard, {
        name: currentUser === null || currentUser === void 0 ? void 0 : currentUser.name,
        email: currentUser === null || currentUser === void 0 ? void 0 : currentUser.email,
        avatarUrl: currentUser === null || currentUser === void 0 ? void 0 : currentUser.avatarUrl,
        onClick: handleSignOut,
        loading: signOutLoading
      })]
    })), jsxs(Stack, Object.assign({
      mt: 6
    }, {
      children: [jsx(Text, Object.assign({
        variant: "body1",
        fontWeight: 700,
        mb: 2
      }, {
        children: t('selectAccountRoleplay.accountsWithAccess')
      })), jsxs(Stack, Object.assign({
        gap: 2
      }, {
        children: [data === null || data === void 0 ? void 0 : data.map(account => jsx(AccountCard, {
          name: account.name,
          email: account.email,
          avatarUrl: account === null || account === void 0 ? void 0 : account.picture,
          onClick: () => handleSignIn(account.userId),
          loading: signInLoading
        }, account.userId)), isFetching && jsx(SelectAccountLoadingState, {})]
      }))]
    }))]
  }));
};

export { SelectAccountRoleplayPage };
